<template>
    <div style="background-color: #F8F9FB;">
        <hhead></hhead>
        <crm-nav></crm-nav>
        <div class="jgMsg_box" style="overflow: hidden;">
            <div class="jgMsg" :style="{
          boxSizing: 'border-box',
          minWidth: '1250px',
        }">
                <div @click="prev" class="prev">
                    <span class="iconfont icon-chehui"></span>&nbsp;点击返回
                </div>
                <!-- <h4
          style="font-size:18px;color: #5B85FF;border-left: 3px solid #5B85FF;padding-left: 10px;line-height: 1;margin-bottom: 20px;"
        >
          合作方信息
        </h4> -->
                <div class="listMsg"
                    style="height: auto;border: none;padding: 0;display: flex;margin-bottom: 0;cursor:default">
                    <!-- 投顾名称 -->
                    <div style="flex: 1;" class="tgName">
                        <div style="display: flex;flex: 1;margin-bottom: 30px;">
                            <img v-if="res.selfImage"
                                :style="{width: res.type==1?'100px':'156px',height: '100px',marginRight: '20px'}"
                                :src="this.$store.state.api + res.selfImage">
                            <img v-if="!res.selfImage && res.type==1"
                                style="width: 156px;height: 100px;margin-right: 20px;"
                                src="../../../../assets/images/crm/tx.jpg">
                            <img v-if="!res.selfImage && res.type==0"
                                style="width: 156px;height: 100px;margin-right: 20px;"
                                src="../../../../assets/images/crm/nav/jg.png">

                            <div style="flex: 1;padding-left: 15px;">
                                <div class="jgName" style="margin-bottom: 20px;">
                                    <h2>{{res.simpleName}}</h2>
                                    <p :style="{border:res.partner!='0'?'1px solid #b541f1':'1px solid #1cbdf2',
                                    color:res.partner!='0'?'#b541f1':'#1cbdf2',
                                    background:res.partner!='0'?'#fbf5ff':'#f7fdff',marginRight:'10px'}">
                                        {{res.partner==0?'甲方':'乙方'}}</p>
                                    <p :style="{border:res.type!='0'?'1px solid #FFAB85':'',
                                            color:res.type!='0'?'#FFAB85':'',
                                            background:res.type!='0'?'#FFFDF8':'',}">{{res.type==0?'企业':'个人'}}</p>
                                    <p v-if=res.interim
                                        :style="{width: '50px',border: '1px solid #ff4a4a',color: '#ff4a4a',backgroundColor:'#fffafa',textAlign: 'center',lineHeight: '23px',marginLeft: '10px',position: 'relative'}">
                                        考察期

                                    </p>
                                </div>

                                <div class="jg_Msg"
                                    style="padding-bottom: 20px;display: flex;justify-content: space-between;padding-right: 100px;">
                                    <li style="flex: auto;display: flex;align-items: center;font-size: 18px;">
                                        <span>联系人：</span>
                                        <p>{{res.contactor}}</p>

                                    </li>
                                    <li style="flex: auto;display: flex;align-items: center;font-size: 18px;">
                                        <span>电话：</span>
                                        <p>{{res.phone}}</p>

                                    </li>

                                    <li style="flex: auto;display: flex;align-items: center;font-size: 18px;">

                                        <span>邮箱：</span>
                                        <p>{{res.mail}}</p>



                                    </li>

                                </div>

                            </div>

                            <div style="flex: .6;display: flex;justify-content: space-between;text-align: center;">
                                <li class="li_input1">
                                    <div style="margin-bottom: 25px;font-size: 18px;">账号数量</div>
                                    <p style="font-size: 30px;color: #5B85FF;">{{res.accCount }}<i
                                            style="font-size: 18px;">个</i> </p>
                                </li>
                                <b style="width: 1px;height: 68px;background-color: #EAEDF2;"></b>
                                <li class="li_input2">
                                    <div style="margin-bottom: 25px;font-size: 18px;">累计收益</div>
                                    <p style="font-size: 30px;color: #FA4B22;">{{res.sumProfit|num1 }}<i
                                            style="font-size: 18px;">%</i></p>
                                </li>
                                <b style="width: 1px;height: 68px;background-color: #EAEDF2;"></b>
                                <li class="li_input3">
                                    <div style="margin-bottom: 25px;font-size: 18px;">累计分红</div>
                                    <p style="font-size: 30px;color: #FA4B22;">{{res.shareMoney|format1 }}<i
                                            v-if="res.shareMoney" style="font-size: 18px;">万</i></p>
                                </li>
                            </div>
                        </div>



                        <!-- <div class="jg_bottom" style="width: auto;margin-bottom: 10px;">
                <p>联系人：{{res.contactor}}</p>
                <p>联系电话：{{res.phone}}</p>
                <p>{{res.type==0?'成立时间':'出生日期'}}：{{res.date|datas}}</p>
                <p>{{res.type==0?'社会信用代码':'身份证号码'}}：{{res.certNum}}</p>
            </div> -->
                        <!-- <div class="titleBox">
                <span>
                    基本信息
                </span>
               
            </div> -->
                        <!-- <div class="information">
                <div v-if="res.type==0">
                    <span>公司简称：</span>
                    <p v-if="edit2">{{res.simpleName}}</p>
                    <el-input v-if="!edit2" v-model="res.simpleName" placeholder="" />
                </div>
                <div>
                    <span>联系人：</span>
                    <p v-if="edit2">{{res.contactor}}</p>
                    <el-input v-if="!edit2" v-model="res.contactor" placeholder="" />
                </div>
                <div>
                    <span>联系电话：</span>
                    <p v-if="edit2">{{res.phone}}</p>
                    <el-input v-if="!edit2" v-model="res.phone" placeholder="" />
                </div>
            </div> -->

                        <div class="titleBox">
                            <span>
                                尽调资料
                            </span>
                            <!-- <p>
                    <i v-if="edit" @click=edit_ class="iconfont icon-bianji "></i>
                    <i v-if="edit" @click=edit_ class="decoration">修改</i>
                    <i v-if="!edit" @click="saveBtn_" class="iconfont icon-baocun "></i>
                    <i v-if="!edit" @click="saveBtn_" class="decoration">保存</i>
                </p> -->
                        </div>
                        <p style="margin-left: 10px;font-size: 18px;padding: 10px 0;">尽调表附件：<a
                                v-if = res.investorInfoFile
                                class="iconfont icon-hetong decoration1" target="_blank"
                                :href="this.$store.state.api+res.investorInfoFile"
                                style="font-size: 18px;color: #5B85FF;cursor: pointer;"></a></p>
                        <p style="margin-left: 10px;font-size: 18px;margin-top: 10px;" class="fwTltle">投资范围：</p>
                        <div v-if="edit" style="margin-left: 10px;margin-bottom: 15px;font-size: 18px;white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;" class="fw">{{res.address}}</div>
                        <div v-if="!edit" class="textareaBox">
                            <el-input type="textarea" rows="3" v-model="res.address"> </el-input>
                        </div>


                    </div>
                </div>
            </div>
        </div>

        <div class="jgMsg_box" style="padding-top: 1px;">
            <div class="jgMsg" :style="{
          boxSizing: 'border-box',
          minWidth: '1250px',
        }">
                <h4
                    style="font-size:18px;color: #5B85FF;border-left: 3px solid #5B85FF;padding-left: 10px;line-height: 1;margin-bottom: 20px;">
                    合作详情
                </h4>
                <div class="htMsg">
                    <div>合作编号：{{ contract.contractNum }}</div>
                    <div>合作起始日：{{ contract.startTime | times }}</div>
                    <div>合作结束日：{{ contract.endTime | times }}</div>
                    <div v-if="contract.remark">备注：{{ contract.remark }}</div>
                    <div v-else>备注：<span style="color: #8C939E;">暂无备注</span></span></div>
                </div>
                <h5>合作进程</h5>
                <div class="steps" style="padding-left: 13px;">
                    <div class="steps_box">
                        <div class="startDate">
                            <span class="yuan"></span>
                            <p class="date">{{ contract.startTime | times }}</p>
                        </div>
                        <div class="name">{{ contract.invSimpleName }}</div>
                        <p class="text_1">添加合作方</p>
                    </div>

                    <div class="steps_box">
                        <div class="startDate">
                            <span class="yuan"></span>
                            <p class="date">{{ contract.startTime | times }}</p>
                        </div>
                        <div class="name">{{ contract.invSimpleName }}</div>
                        <p class="text_1">尽调沟通</p>
                    </div>

                    <div class="steps_box">
                        <div class="startDate">
                            <span class="yuan"></span>
                            <p class="date">{{ contract.startTime | times }}</p>
                        </div>
                        <div class="name">{{ contract.contractNum }}</div>
                        <p class="text_1">
                            合作签订&nbsp;<a :href="this.$store.state.api + contract.contractFile"
                                style="color: #3D6BF1;cursor: pointer;font-size: 16px;"
                                class=" iconfont icon-hetong decoration1"></a>
                        </p>
                    </div>

                    <div style="position: relative;" v-for="(item, index) in contract.accList">
                        <span style="    width: 12px;
            height: 12px;
            display: block;
            background: #5b85ff;
            border-radius: 50%;
            margin-left: -6px;
            position: absolute;
            z-index: 100;
            top: 8px;" class="yuan"></span>
                        <div class="steps_x">
                            <p class="datee">
                                {{ item.startTime | times }}<br />
                                {{ item.startTime | timesR }}<br />
                                <!-- <span
                  :style="{
                    marginLeft: '10px',
                    textAlign: 'center',
                    display: 'block',
                    color: item.state == '0' ? '#31b4ff' : '#FB6060',
                    backgroundColor: item.state == '0' ? '#ebf9ff' : '#fff5f4',
                    borderRadius: '10px',
                    width: '50px',
                    padding: '2px 0',
                  }"
                  >{{ item.state == '0' ? '合作中' : '已终止' }}</span
                > -->
                            </p>

                            <p @click="pushUser(item.id)" class="text_1 hoverColor"
                                style="color: #181E2D;padding-left: 0;cursor: pointer;">
                                账户：<span style="display: inline-block;min-width: 90px;">{{ item.userCode }}</span>
                                姓名：

                                {{ item.userName }}

                                <i>（{{ item.startTime | times }}~{{
                    item.endTime | times
                  }}）</i>
                            </p>
                        </div>
                        <div class="steps_x">
                            <div class="steps_li">
                                <p></p>
                                <span>{{ item.startTime | times }}</span>
                                <h6>开立</h6>
                            </div>

                            <div class="steps_li" v-for="(e, i) in item.shareRecordList" :key="i">
                                <p></p>
                                <span>{{ e.shareTime | times }}</span>
                                <h6>
                                    分红
                                    <li>{{ e.shareMoney | format }}元</li>
                                </h6>
                            </div>

                            <div class="steps_li">
                                <p :style="{
                    background: item.state == 0 ? '#5B85FF' : '#F74040',
                   
                  }"></p>
                                <span>{{ item.endTime | times }}</span>
                                <h6 :style="{ color: item.state == 0 ? '#5B85FF' : '#F74040' }">
                                    {{ item.state == '0' ? '进行中' : '合作到期' }}
                                </h6>
                            </div>
                        </div>
                    </div>

                    <div class="steps_box">
                        <div class="startDate">
                            <span :style="{ background: contract.state == 0 ? '#CED5E4' : '#F74040' }"
                                class="yuan"></span>
                            <p class="date">
                                {{
                  contract.state == 0 ? currentdate : contract.endTime | times
                }}
                            </p>
                        </div>
                        <div class="name">{{ contract.contractNum }}</div>
                        <p :style="{ color: contract.state == 0 ? '#5B85FF' : '#F74040' }" class="text_1">
                            {{ contract.state == 0 ? '合作进行中' : '合作终止' }}
                        </p>
                    </div>
                </div>

                <div class="table" style="padding-left: 13px;">
                    <h5 style="margin-left: 0;">账户列表</h5>
                    <el-table border :data="contract.accList" size="medium" style="width: 100%"
                        :header-cell-style="{ textAlign: 'center' }">
                        <el-table-column align="center" prop="userCode" label="账户">
                        </el-table-column>
                        <el-table-column prop="userName" label="姓名" align="center">
                        </el-table-column>

                        <el-table-column align="center" prop="contractNum" label="合作编号">
                        </el-table-column>
                        <el-table-column align="center" prop="cooCycle" label="合作周期">
                        </el-table-column>

                        <el-table-column prop="shareMoney" align="right" label="累计分红">
                            <template slot-scope="scope">{{
                scope.row.shareMoney | format
              }}</template>
                        </el-table-column>
                        <el-table-column prop="sumNet" align="right" label="净值">
                            <template slot-scope="scope">
                                <span :style="{
                    color: scope.row.sumNet > 1 ? '#FA5D22' : '#3ABA94',
                  }">{{ scope.row.sumNet | num3 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="thisYearProfit" align="right" label="今年来">
                            <template slot-scope="scope">
                                <span :style="{
                    color:
                      scope.row.thisYearProfit >= 0 ? '#FA5D22' : '#3ABA94',
                  }">{{ scope.row.thisYearProfit | num }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="thisMonthProfit" align="right" label="月内">
                            <template slot-scope="scope">
                                <span :style="{
                    color:
                      scope.row.thisMonthProfit >= 0 ? '#FA5D22' : '#3ABA94',
                  }">{{ scope.row.thisMonthProfit | num }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="profitRate" align="right" label="累计">
                            <template slot-scope="scope">
                                <span :style="{
                    color: scope.row.profitRate >= 0 ? '#FA5D22' : '#3ABA94',
                  }">{{ scope.row.profitRate | num }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="yearlyProfitRate" align="right" label="年化">
                            <template slot-scope="scope">
                                <span :style="{
                    color:
                      scope.row.yearlyProfitRate >= 0 ? '#FA5D22' : '#3ABA94',
                  }">{{ scope.row.yearlyProfitRate | num }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="display: flex;">
                        <div @click="adduser" class="el-icon-plus" :style="{cursor: 'pointer',background:'#fff',
                            width: '100px',
                            height: '32px',
                            textAlign: 'center',
                            boxSizing: 'border-box',
                            border: 0,
                            lineHeight: '30px',             
                            fontSize: '16px',
                            marginRight: '20px',
                            color: '#5b85ff',
                            borderRadius: '2px',
                            marginTop:'20px',
                            border:'1px solid #5b85ff',
                            boxSizing:'border-box'
                        }">添加账号</div>
                        <div @click="contractBtn" :style="{
              cursor: 'pointer',
              background: accList.length > 0 ? '#5b85ff' : '#C2C7CE',
              width: '100px',
              height: '32px',
              textAlign: 'center',
              boxSizing: 'border-box',
              border: 0,
              lineHeight: '32px',
              fontSize: '16px',
              marginRight: '20px',
              color: '#fff',
              borderRadius: '2px',
              marginTop: '20px',
            }">
                            点击分析
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <transition name="el-fade-in-linear">
            <!--  添加遮罩层 -->
            <div class="popContainer" v-show="adduserShow">
                <div class="add" :style="{ width: '800px',paddingBottom:'15PX' }">
                    <div class="close"></div>
                    <div class="Top" :style="{ width: '800px' }">
                        添加
                    </div>
                    <span @click="closeBtn" class="close iconfont icon-close_round_fill_bold
          "></span>
                    <div class="form_box" style="width: 100%;">
                        <div class="searchUserBox searchBox">
                            <el-input v-model="userSearch" placeholder="请输入账户"></el-input>
                            <el-input v-model="nameSearch" placeholder="请输入姓名"></el-input>
                            <input class="btn" type="button" style="margin-top: 15px;" @click='searchBtn' value="搜索" />
                            <input style="color: #fff;background-color: #5B85FF;margin-top: 15px;" class="btn"
                                @click='resetBtn' type="reset" value="重置" />
                        </div>

                        <div class="table" style="margin-top: 40px;">
                            <el-table height='400' border :data="resList" size="medium" style="width: 100%"
                                :header-cell-style="{textAlign: 'center'}" :row-class-name="tableRowClassName">
                                <el-table-column width="50" :render-header="renderHeader">
                                    <template slot-scope="scope">
                                        <el-checkbox @change="checkBtn(scope.row.deleted,scope.row.id)"
                                            v-model="scope.row.deleted"></el-checkbox>
                                    </template>
                                </el-table-column>


                                <el-table-column align='center' prop="userCode" label="账户">

                                </el-table-column>
                                <el-table-column prop="userName" label="姓名""
                            align='center'
                          >
                          </el-table-column>
                  
                        <!-- <el-table-column  prop='' align='center' width=" 90" label="状态">
                                    <template slot-scope="scope">
                                        <span class="stateYuan" v-if="scope.row.edit" :style="{color:scope.row.state==0?'#31b4ff':scope.row.state==2?'#fb6060':'',
                                background:scope.row.state==0?'#ebf9ff':scope.row.state==2?'#fff5f4':'',padding:'4px 1px 4px 10px',
                                  display:'block',
                                  borderRadius: '6px',position:'relative'
                              }"><i :style="{display:'inline-block',borderRadius: '50%',width: '5px',height:'5px',
                              background:scope.row.state==0?'#31b4ff':scope.row.state==2?'#fb6060':'',position:'absolute',top:'11px',left:'10px'
                          }"></i> {{scope.row.state==0?'合作中':(scope.row.state==1?'合作暂停': '已终止')}}</span>
                                        <span class="stateYuan" v-if="!scope.row.edit" :style="{color:'#868E99',
                                background:'#f1f4f7',padding:'4px 1px 4px 10px',
                                  display:'block',
                                  borderRadius: '6px',position:'relative'
                              }"><i :style="{display:'inline-block',borderRadius: '50%',width: '5px',height:'5px',
                              background:'#868E99',position:'absolute',top:'11px',left:'10px'
                          }"></i>未编辑</span>
                                    </template>
                                </el-table-column> -->

                                <el-table-column prop='shareMoney' align='right' label="累计分红">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.shareMoney|format}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="sumNet" width="80" align='right' label="净值">
                                    <template slot-scope="scope">
                                        <span
                                            :style="{color:scope.row.sumNet>1?'#FA5D22':'#3ABA94'}">{{scope.row.sumNet|num3}}</span>
                                    </template>
                                </el-table-column>

                                <el-table-column
                            prop="simpleName"
                            label="合作方名称"
                            align='center'
                          >
                          </el-table-column>

                          <el-table-column
                            prop="contractNum"
                            label="合作编号""
                            align='center'
                          >
                          </el-table-column>




                            </el-table>
                        </div>
                        <!-- <div class="page_box">
                            <div class="msg_count">共&nbsp;{{ length?length:'0' }}&nbsp;条</div>
                            <div class="blank"></div>
                            <div class="page">
                              <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="pageLength ? pageLength : 0"
                            
                                @current-change="currentPage"
                              >
                              </el-pagination>
                            </div>
                          </div> -->




                    </div>
                    <div class="form_btn">

                        <button @click= 'submit'>提交</button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
    import hhead from '../../header/index';
    import crmNav from '../../../../components/crmNav/index';
    import './style.css';
    export default {
        components: { hhead, crmNav },
        data() {
            return {
                MHeight: document.documentElement.clientHeight - 94 + 'px',
                res: '', //投顾信息
                contract: '', //合作详情
                accList: [],
                currentdate: '',
                edit2: true,
                edit: true,
                adduserShow: false,
                userSearch: '',
                nameSearch: '',
                logLevel: false,
                resList: []
            };
        },
        filters: {
            datas: function (date) {
                if (date) {
                    return (
                        date
                            .substr(0, 10)
                            .replace('/', '年')
                            .replace('/', '月') + '日'
                    );
                }
            },
            times: function (date) {
                if (date) {
                    return date.substr(0, 10);
                }
            },
            timesR: function (date) {
                if (date) {
                    return date.substr(11, 5);
                }
            },
            num: function (n) {
                //数字格式化
                if (n) {

                    return (Math.round(n * 10000) / 100).toFixed(2) + '%';
                } else {
                    return '0.00'
                }
            },
            num1: function (n) {
                if (n) {
                    return (Math.round(n * 10000) / 100).toFixed(2);
                } else {
                    return '0.00';
                }
            },
            num3: function (n) {
                if (n) {
                    return n.toFixed(4);
                }
            },
            format1: function (n) {
                if (n) {
                    return Math.round(n / 10000)
                } else {
                    return '0';
                }
            },
            format: function (n) {
                if (n) {
                    // console.log(n)
                    return (n * 1).toFixed(2);
                } else {
                    return '0.00';
                }
            },
        },
        mounted() {
            var date = new Date();
            var seperator1 = '/';
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = '0' + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = '0' + strDate;
            }
            this.currentdate = year + seperator1 + month + seperator1 + strDate;

            this.userAxios()

            // 合作详情
            this.cList()


            this.list()
        },
        methods: {
            cList(){
                this.$axios
                .post('/crm/contract/queryOneContract', {
                    apiToken: this.$store.state.usermsg.apiToken,
                    entConId: this.$route.query.entConId,
                })
                .then((res) => {
                    // console.log(res);
                    if (res.data.code == 200) {
                        this.contract = res.data.data;
                        this.accList = res.data.data.accList;
                    }
                });
            },
            userAxios(){
                this.$axios
                .post('/crm/inverstor/queryInvestor', {
                    apiToken: this.$store.state.usermsg.apiToken,
                    invId: this.$route.query.id,
                })
                .then((res) => {
                    // console.log(res);
                    this.tokenInvalid(res);
                    if (res.data.code == 200) {
                        this.res = res.data.data;
                    }
                });
            },
            submit(){//提交
                let id = ''
                this.resList.forEach(item=>{
                    if(item.deleted){
                        id += ','+item.id
                    }
                })
                this.$axios.post(
                    '/crm/contract/addAccsOnContract',
                    {
                        apiToken:this.$store.state.usermsg.apiToken,
                        contractId:this.$route.query.entConId,
                        accs:id.replace(',','')
                    }
                ).then(res=>{
                    if(res.data.code == 200){
                        this.cList()
                        this.userAxios()
                        this.adduserShow = false
                        this.userSearch = ''
                        this.nameSearch = ''
                        this.userAxios()
                        this.logLevel = false
                        this.list()
                    }else{
                        this.$alert(res.data.message, {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true,
                    })
                        .then(() => { })
                        .catch(() => { });
                    }
                    console.log(res)
                }).catch(err=>{
                    console.log(err)
                })
            },
            list() {
                this.$axios.post(
                    '/crm/query_all_acc',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        contractId: this.$route.query.entConId
                    }
                ).then(res => {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.resList = []
                        res.data.data.forEach(item => {
                            item.isShow = true

                            this.resList.push(item)
                        })
                        console.log(this.resList)
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            
            searchBtn(){//搜索按钮
                this.resList.forEach(item=>{
                   
                    if(item.userCode.indexOf(this.userSearch+'')!=-1&&item.userName.indexOf(this.nameSearch+'')!=-1){
                        item.isShow = true
                    }else{
                        item.isShow = false 
                    }
                })
            },
            resetBtn() {
                this.userSearch = ''
                this.nameSearch = ''
                this.searchBtn()
            },
            checkBtn(e,id){
       
       if(e){
           let i = 0
           this.resList.forEach(item=>{
               if(item.deleted){
                   i++
               }
           })
           if(i==this.resList.length){

                   this.logLevel =true
           }
        
        
       }else{
         this.logLevel =false
       
         
       }
     //   console.log(this.arrId)
     },
            closeBtn() {
                this.adduserShow = false
                this.logLevel = false
                this.list()
            },
            adduser() {
                this.adduserShow = true
            },
            edit_() {
                this.edit = false
            },
            renderHeader(h, { column }) {
                return (
                    'span',
                    [
                        h('el-checkbox', {
                            on: {
                                change: this.select
                            },
                            props: {
                                value: this.logLevel //文字框的内容取决于这个value，如果value不存在，会报错
                            }
                        }),
                        h('span', column.label)
                    ]
                )
            },
            tableRowClassName(row, index) {

                if (!row.row.isShow) {
                    return 'hidden-row'
                } else {
                    return ''
                }
            },
            select(checked) {
                // 如果checked为true则是勾选了对应的表头
                //   console.log(checked)
                this.logLevel = checked
                if (this.logLevel) { //全选

                    this.resList.forEach((item, index) => {
                        item.deleted = true
                        // if(item.deleted == false){  //判断全选之前没有选中的
                        //     this.arrId.push(item.id) //没有选中的ID push到arrId数组
                        // } 
                    })

                } else {  //全不选
                    this.resList.forEach(item => {
                        item.deleted = false
                        // this.arrId.forEach((e,i)=>{ //从arrId数组里删除未选中的ID
                        //     if(e == item.id){
                        //         this.arrId.splice(i,1)
                        //     }
                        // })
                    })

                }
                //   console.log(this.arrId)
            },
            saveBtn_() {


                this.$axios.post(
                    '/crm/inverstor/editInv',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        address: this.res.address,
                        invId: this.$route.query.id,
                        phone: '',
                        contactor: this.res.contactor,
                        simpleName: this.res.simpleName,
                    }
                ).then(res => {
                    // console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {

                        this.edit = true
                    }
                })


            },
            editBtn() {
                this.edit2 = false
            },
            saveBtn() {
                if (/^1[3456789]\d{9}$/.test(this.res.phone)) {

                    this.$axios.post(
                        '/crm/inverstor/editInv',
                        {
                            apiToken: this.$store.state.usermsg.apiToken,
                            phone: this.res.phone,
                            contactor: this.res.contactor,
                            simpleName: this.res.simpleName,
                            invId: this.$route.query.id
                        }
                    ).then(res => {
                        // console.log(res)
                        this.tokenInvalid(res)
                        if (res.data.code == 200) {

                            this.edit2 = true
                        }
                    })
                } else {
                    this.$alert('请输入正确的手机号', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true,
                    })
                        .then(() => { })
                        .catch(() => { });
                }
            },
            pushUser(id) {
                // 跳转账户详情
                window.open('_blank').location.href = `/crm/user/uDetails?id=${id}`;
            },
            contractBtn() {
                //点击分析
                let arrId = this.$route.query.entConId;
                if (this.contract.accList.length > 0) {
                    window.open(
                        '_blank'
                    ).location.href = `/crm/analysis/Fitting?contractId=${arrId}`;
                } else {
                    this.$alert('暂无账户进行分析', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true,
                    })
                        .then(() => { })
                        .catch(() => { });
                }
            },
            prev() {
                this.$router.go(-1);
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/view/crm/contract/CDetails/index.vue